<div class="page-layout carded fullwidth">
    <!-- TOP BACKGROUND -->
    <div class="top-bg accent"></div>
    <!-- / TOP BACKGROUND -->

    <!-- CENTER -->
    <div class="center">
        <!-- CONTENT HEADER -->
        <div
            class="header accent p-24"
            fxLayout="row"
            fxLayoutAlign="start center"
        >
            <h2 class="m-0">
                Operación
                <span *ngIf="!editar_nombre" class="px-20">{{
                    debidaDiligencia?.beneficiarioPersonaJuridica
                        ?.nombreBeneficiario ||
                        debidaDiligencia?.beneficiarioPersonaFisica
                            ?.nombreCompleto
                }}</span>
                <input
                    placeholder="Nombre"
                    matInput
                    [(ngModel)]="nombre"
                    *ngIf="editar_nombre"
                />
                <mat-icon
                    *ngIf="editar_nombre"
                    aria-hidden="false"
                    aria-label="Editar estado"
                    (click)="updateName(nombre)"
                    >save</mat-icon
                >
                <mat-icon
                    *ngIf="
                        is_eval_creador && debidaDiligencia?.estado != 'CERRADO'
                    "
                    aria-hidden="false"
                    aria-label="Editar nombre"
                    (click)="editar_nombre = true"
                    >edit</mat-icon
                >
            </h2>
        </div>
        <!-- / CONTENT HEADER -->

        <!-- CONTENT CARD -->
        <div class="content-card">
            <!-- CONTENT TOOLBAR -->
            <div class="toolbar px-24 py-8">
                <div>
                    <!--   -->
                    <mat-horizontal-stepper
                        [linear]="true"
                        #stepper
                        [selectedIndex]="this.selectedStatus"
                        (selectionChange)="setIndex($event)"
                        (click)="changeStatus()"
                        style="max-height: 60px"
                    >
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone0"
                            [state]="isStepDone0"
                        >
                            <form [formGroup]="preiniciadoFormGroup">
                                <ng-template matStepLabel>Iniciada</ng-template>
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone1"
                            [state]="isStepDone1"
                        >
                            <form [formGroup]="completadoFormGroup">
                                <ng-template matStepLabel
                                    >Completada</ng-template
                                >
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                        <mat-step
                            [editable]="isEditable"
                            [completed]="isThisStepDone2"
                            [state]="isStepDone2"
                        >
                            <form [formGroup]="cerradoFormGroup">
                                <ng-template matStepLabel>Revisada</ng-template>
                                <input
                                    matInput
                                    placeholder="Last name, First name"
                                    required
                                    class="invisible example-full-width"
                                />
                            </form>
                        </mat-step>
                    </mat-horizontal-stepper>
                </div>
                <div fxFlex fxLayout="row" fxLayoutAlign="end center">
                    <button
                        mat-button
                        (click)="print()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="print"
                            >print</mat-icon
                        >
                    </button>
                    <button
                        mat-button
                        (click)="goBack()"
                        mat-flat-button
                        color="primary"
                        class="add-row"
                    >
                        <mat-icon aria-hidden="false" aria-label="Salir"
                            >exit_to_app</mat-icon
                        >
                        Salir
                    </button>
                </div>
            </div>
            <!-- / CONTENT TOOLBAR -->

            <!-- CONTENT -->
            <div class="content p-24" style="max-height: 200px !important">
                <div id="scan" class="p-24" fxLayout="row" xFlex="100">
                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr>
                                    <td class="label">Cliente</td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                debidaDiligencia?.cliente !=
                                                null
                                            "
                                            >{{
                                                debidaDiligencia?.cliente
                                                    ?.nombre
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">
                                        Documento de identidad
                                    </td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                debidaDiligencia?.cliente !=
                                                null
                                            "
                                            >{{
                                                debidaDiligencia?.cliente
                                                    ?.razonSocial?.tipo?.nombre
                                            }}
                                            /
                                            {{
                                                debidaDiligencia?.cliente
                                                    ?.razonSocial?.numero
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Tipo de operación</td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                debidaDiligencia?.tipoOperacion
                                                    ?.nombre != null
                                            "
                                            >{{
                                                debidaDiligencia?.tipoOperacion
                                                    ?.nombre
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Sector</td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                debidaDiligencia
                                                    ?.sectorIndustrial
                                                    ?.nombre != null
                                            "
                                            >{{
                                                debidaDiligencia
                                                    ?.sectorIndustrial?.nombre
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">País</td>
                                    <td class="value">
                                        <span
                                            class="px-20"
                                            *ngIf="
                                                debidaDiligencia?.pais
                                                    ?.nombre != null
                                            "
                                            >{{
                                                debidaDiligencia?.pais?.nombre
                                            }}</span
                                        >
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="openDialog()"
                                            >Editar</a
                                        >
                                        <!--<mat-icon  aria-hidden="false" aria-label="Editar estado" (click)="openDialog()" >edit</mat-icon>-->
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>

                    <div
                        fxLayout="column"
                        fxFlex="100"
                        fxFlex.gt-sm="100"
                        fxFlex.gt-md="50"
                    >
                        <div
                            class="profile-box info-box general"
                            fxLayout="column"
                        >
                            <table class="summary">
                                <tr class="code">
                                    <td class="label">Beneficiario</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_responsable"
                                            class="px-20"
                                        >
                                            {{
                                                debidaDiligencia?.nombreBeneficiario
                                            }}
                                        </span>
                                        <!--
                                  <mat-form-field *ngIf="editar_responsable" fxFlex>
                                    <mat-label>Responsable</mat-label>
                                    <mat-select [(ngModel)]="debidaDiligencia.responsable" class="roleSelect" (selectionChange)="selectDueno($event)">

                                      <ng-container *ngFor="let usuario of debidaDiligencia?.nodoEstructuraJerarquica?.usuarios">
                                        <mat-option *ngIf="esEvaluadorGroup(usuario)" [value]="usuario">
                                          {{usuario.nombreCompleto}}
                                        </mat-option>
                                      </ng-container>
                                      
                                        <mat-option *ngFor="let usuario of debidaDiligencia.nodoEstructuraJerarquica.usuarios" *ngIf="esOwnersGroup(usuario)" [value]="usuario">
                                            {{usuario.nombreCompleto}}
                                        </mat-option>
                                        
                                    </mat-select>
                                  </mat-form-field>
                                  -->
                                        <a
                                            *ngIf="is_eval_creador"
                                            (click)="editar_responsable = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && debidaDiligencia?.estado=='INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_dueno=true" >edit</mat-icon>-->
                                    </td>
                                </tr>

                                <tr>
                                    <td class="label">Fecha de vigencia</td>
                                    <td class="value">
                                        <span
                                            *ngIf="!editar_fecha_fin"
                                            class="px-20"
                                            >{{
                                                debidaDiligencia?.fechaVencimiento
                                                    | date : "dd/MM/yyyy"
                                            }}</span
                                        >
                                        <mat-form-field
                                            color="accent"
                                            *ngIf="editar_fecha_fin"
                                            fxFlex
                                        >
                                            <mat-label
                                                >Fecha de vigencia</mat-label
                                            >
                                            <input
                                                matInput
                                                [matDatepicker]="picker2"
                                                [min]="fechaInicio"
                                                [(ngModel)]="fechaFin"
                                                (dateChange)="
                                                    selectFechaFin($event)
                                                "
                                            />
                                            <mat-datepicker-toggle
                                                matSuffix
                                                [for]="picker2"
                                            ></mat-datepicker-toggle>
                                            <mat-datepicker
                                                #picker2
                                            ></mat-datepicker>
                                        </mat-form-field>
                                        <a
                                            *ngIf="
                                                is_eval_creador &&
                                                debidaDiligencia?.estado ==
                                                    'INICIADO'
                                            "
                                            (click)="editar_fecha_fin = true"
                                            >Editar</a
                                        >
                                        <!--<mat-icon *ngIf="(is_owner && debidaDiligencia?.estado=='INICIADO') || (is_eval_creador)" aria-hidden="false" aria-label="Editar estado" (click)="editar_fecha_fin=true" >edit</mat-icon>-->
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Creado por</td>
                                    <td class="value">
                                        <span class="px-20">{{
                                            debidaDiligencia?.remitente
                                                ?.nombreCompleto
                                        }}</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Monto</td>
                                    <td class="value">
                                        <span class="px-20"
                                            >{{
                                                debidaDiligencia.moneda?.simbolo
                                            }}
                                            {{
                                                debidaDiligencia.monto
                                                    | number : "1.2-3" : "es"
                                            }}</span
                                        >
                                    </td>
                                </tr>
                                <tr>
                                    <td class="label">Tipo de debida diligencia</td>
                                    <td class="value">
                                        <span class="px-20"
                                        >
                                            {{
                                                debidaDiligencia.tiposFormulario
                                                    | translate
                                            }}</span
                                        >
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <!-- / CONTENT -->

            <!-- TABS -->

            <div class="content">
                <!-- <sentencia-tree [dataSource]="this.debidaDiligencia?.marcoDeReferencia" 
                        [tablaDeEvaluacion]="debidaDiligencia?.tablaDeEvaluacion"
                        [debidaDiligenciaEstado]="debidaDiligencia?.estado"
                        [isResponsable]="is_responsable" 
                        ></sentencia-tree>  -->

                <mat-tab-group>
                    <mat-tab label="Solicitud de información">
                        <!--<div fxFlex fxLayout="column">-->

                        <div
                            class="widget-group"
                            fxLayout="column wrap"
                            fxFlex="100"
                            *fuseIfOnDom
                        >
                            <div class="content p-24">
                                <button
                                    mat-button
                                    (click)="
                                        openDialogNuevoFormulario('Add', {})
                                    "
                                    mat-flat-button
                                    color="primary"
                                    class="add-row"
                                >
                                    Nuevo formulario
                                </button>

                            <table
                                mat-table
                                [dataSource]="dataSource"
                                #mytable
                                class="my-table mat-elevation-z8"
                            >
                                <ng-container matColumnDef="destinatario">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Destinatario
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.destinatario?.nombre }}
                                        {{ element.destinatario?.apellido }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="formulario">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Formulario
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.formulario?.nombre }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="estado">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Estado
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{ element.formulario?.estado }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="fechaFin">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Fecha de creación
                                    </th>
                                    <td mat-cell *matCellDef="let element">
                                        {{
                                            element.formulario?.fechaCreado
                                                | date : "dd/MM/yyyy"
                                        }}
                                    </td>
                                </ng-container>

                                <ng-container matColumnDef="action">
                                    <th mat-header-cell *matHeaderCellDef>
                                        Acción
                                    </th>
                                    <td
                                        mat-cell
                                        *matCellDef="let element"
                                        class="action-link"
                                    >
                                        <a
                                            (click)="
                                                navegateTo(
                                                    element.formulario?.id
                                                )
                                            "
                                            >Ver</a
                                        >
                                        <spa
                                            *ngIf="
                                                debidaDiligencia?.estado !=
                                                'CERRADO'
                                            "
                                            >|</spa
                                        >
                                        <a
                                            *ngIf="
                                                debidaDiligencia?.estado !=
                                                'CERRADO'
                                            "
                                            (click)="openDialog(element)"
                                            >Eliminar</a
                                        >
                                    </td>
                                </ng-container>

                                <tr
                                    mat-header-row
                                    *matHeaderRowDef="displayedColumns"
                                ></tr>
                                <tr
                                    mat-row
                                    *matRowDef="
                                        let row;
                                        columns: displayedColumns
                                    "
                                ></tr>
                            </table>
                        </div>
                        </div>
                    </mat-tab>
                    <mat-tab label="Conclusión">
                        <!-- <div fxFlex fxLayout="column" class="p-24"
                       [innerHTML]="debidaDiligencia?.conclusion">
                        
                      </div> -->
                        <textarea
                            fxFlex
                            fxLayout="row"
                            style="width: 100%; height: 400px"
                            [(ngModel)]="debidaDiligencia.conclusion"
                            [disabled]="
                                debidaDiligencia?.estado == 'COMPLETADO' ||
                                debidaDiligencia?.estado == 'CERRADO'
                            "
                        ></textarea>
                        <button
                            mat-button
                            (click)="guardarConclusion()"
                            mat-flat-button
                            color="primary"
                            class="add-row"
                            [disabled]="
                                debidaDiligencia?.estado == 'COMPLETADO' ||
                                debidaDiligencia?.estado == 'CERRADO'
                            "
                        >
                            <mat-icon aria-hidden="false" aria-label="Guardar"
                                >save</mat-icon
                            >
                            Guardar
                        </button>
                    </mat-tab>
                </mat-tab-group>
            </div>
            <!-- TABS fin -->
        </div>
        <!-- / CONTENT CARD -->
    </div>
    <!-- / CENTER -->
</div>
